import React from 'react'
import { Link } from 'react-router-dom'
import Lightbox from "yet-another-react-lightbox";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/styles.css";
import Logo from '../../images/TLM Logo.png'
import shape1 from '../../images/icons/icon-5.png'
import shape2 from '../../images/icons/icon-6.png'
import shape3 from '../../images/icons/icon-7.png'
import shape4 from '../../images/icons/icon-8.png'
import shape5 from '../../images/icons/icon-9.png'
import shape6 from '../../images/icons/icon-10.png'


import pImg1 from '../../images/instagram/insta6.jpg'
import pImg2 from '../../images/instagram/insta5.png'
import pImg3 from '../../images/instagram/insta4.png'
import pImg4 from '../../images/instagram/insta3.png'
import pImg5 from '../../images/instagram/insta2.png'
import pImg6 from '../../images/instagram/insta1.png'
import pImg7 from '../../images/gallery/7.jpg'
import pImg8 from '../../images/gallery/8.jpg'

const images = [
    { 
        src: pImg1,
        posturl: "https://www.instagram.com/p/DPN8Q-Wkq14/?hl=en"
    },
    { 
        src: pImg2,
        posturl: "https://www.instagram.com/p/DOfvNMUkpko/?hl=en"
    },
    { 
        src: pImg3,
        posturl: "https://www.instagram.com/p/DOOGORykr7Q/?hl=en&img_index=1"
    },
    { 
        src: pImg4,
        posturl: "https://www.instagram.com/p/DLO5QpByg6b/?hl=en&img_index=1"
    },
    { 
        src: pImg5,
        posturl: "https://www.instagram.com/p/DN2bxBJZFA9/?hl=en&img_index=1"
    },
    {
        src: pImg6,
        posturl: "https://www.instagram.com/the.lushminds/p/DO-YbQekglQ/?hl=en"
    },
];


const Footer2 = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    const [open, setOpen] = React.useState(false);

    return (
        <footer className="footer-two">
            <div className="footer-two_icon-one" style={{ backgroundImage: `url(${shape1})` }}></div>
            <div className="footer-two_icon-two" style={{ backgroundImage: `url(${shape1})` }}></div>
            <div className="footer-two_icon-three" style={{ backgroundImage: `url(${shape2})` }}></div>
            <div className="footer-two_icon-four" style={{ backgroundImage: `url(${shape2})` }}></div>
            <div className="footer-two_icon-five" style={{ backgroundImage: `url(${shape3})` }}></div>
            <div className="footer-two_icon-six" style={{ backgroundImage: `url(${shape4})` }}></div>
            <div className="footer-two_icon-seven" style={{ backgroundImage: `url(${shape5})` }}></div>
            <div className="footer-two_icon-eight" style={{ backgroundImage: `url(${shape6})` }}></div>
            <div className="auto-container">
                <div className="footer-two-widgets">
                    <div className="row clearfix">
                        <div className="big-column col-lg-6 col-md-12 col-sm-12">
                            <div className="row clearfix">
                                <div className="footer-two_column col-lg-7 col-md-6 col-sm-12">
                                    <div className="footer-two-widget logo-widget">
                                        <div className="footer-two_logo">
                                            <a href="/" rel="noopener noreferrer"><img src={Logo} alt="" style={{ width: '50%', height: '50%' }} /></a>
                                        </div>
                                        <div className="footer-two_text">At The Lush Minds, growth thrives where connection, learning, and well-being unite, empowering your journey forward.</div>
                                    </div>
                                </div>
                                <div className="footer-two_column col-lg-5 col-md-6 col-sm-12">
                                    <div className="footer-two-widget links-widget">
                                        {/* <h4 className="footer-two_title">Links</h4> */}
                                        <ul className="footer-two_list">
                                            {/* <li><Link onClick={ClickHandler} to="/">Home</Link></li>
                                            <li><Link onClick={ClickHandler} to="/">About</Link></li>
                                            <li><Link onClick={ClickHandler} to="/">Services</Link></li>
                                            <li><Link onClick={ClickHandler} to="/">Projects</Link></li>
                                            <li><Link onClick={ClickHandler} to="/">Blogs</Link></li>
                                            <li><Link onClick={ClickHandler} to="/">Contact</Link></li> */}
                                        </ul>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className="big-column col-lg-6 col-md-12 col-sm-12">
                            <div className="row clearfix">
                                <div className="main-footer_column col-lg-6 col-md-6 col-sm-12">
                                    <div className="footer-widget news-widget">
                                        <h4 className="footer-two_title">Information</h4>
                                        <ul className="footer-two_contact-list">
                                            <li><i className="icon fa fa-phone"></i>+91 98642 54608</li>
                                            <li><i className="icon fa fa-envelope"></i> <a href="mailto:">hello@thelushminds.in</a></li>
                                            <li><i className="icon fa fa-map-marker"></i>Guwahati, Assam</li>
                                        </ul>
                                        <ul className="footer-two_socials">
                                            {/* <li><Link onClick={ClickHandler} to="/" className="fa fa-twitter"></Link></li> */}
                                            <li><a href="https://www.facebook.com/share/1A2ucU11FV/" target="_blank" rel="noopener noreferrer" className="fa fa-facebook"></a></li>
                                            {/* <li><Link onClick={ClickHandler} to="/" className="fa fa-dribbble"></Link></li> */}
                                            <li><a href="https://www.linkedin.com/company/thelushminds/" target="_blank" rel="noopener noreferrer" className="fa fa-linkedin"></a></li>
                                            <li><a href="https://www.youtube.com/@the.lushminds" target="_blank" rel="noopener noreferrer" className="fa fa-youtube"></a></li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="main-footer_column col-lg-6 col-md-6 col-sm-12">
                                    <div className="footer-widget instagram-widget">
                                        <h4 className="footer-two_title">instagram</h4>
                                        <div className="images-outer clearfix">
                                            {images.slice(0, 6).map((item, pitem) => (
                                                item.posturl ? (
                                                    <a href={item.posturl} target="_blank" rel="noopener noreferrer" key={pitem}>
                                                        <figure className="image-box"><img src={item.src} alt="" /></figure>
                                                    </a>
                                                ) : (
                                                    <figure className="image-box" key={pitem} onClick={() => setOpen(true)}><img src={item.src || item} alt="" /></figure>
                                                )
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
            <div className="footer-bottom">
                <div className="auto-container">
                    <div className="row clearfix" style={{ justifyContent: 'center', display: 'flex' }}>
                        <div className="column col-12" style={{ textAlign: 'center', width: '100%' }}>
                            <div className="copyright">&copy;  Copyright ©2025 The Lush Minds. All Rights Reserved</div>
                        </div>
                    </div>
                </div>
            </div>

            <Lightbox
                open={open}
                close={() => setOpen(false)}
                slides={[
                    { src: pImg1 },
                    { src: pImg2 },
                    { src: pImg3 },
                    { src: pImg4 },
                    { src: pImg5 },
                    { src: pImg6 },
                ]}
                plugins={[Zoom]}
            />

        </footer>
    )
}

export default Footer2;